module.exports = __webpack_public_path__ + "bc01eef4803f3b4ca10615fa40c49878.png";